module.exports = __webpack_public_path__ + "static/img/old_sys_icon.6438b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/old_sys_icon.png
// module id = 65
// module chunks = 0